module.exports = __webpack_public_path__ + "img/img_6.75b00866.svg";